import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { pathPickOrderHistoryQueryApi } from "@/features/pathpick/features/order-history/api/query";
import { PathPickOrdersRequestParams } from "@/features/pathpick/features/order-history/types/request-params";
import { PathPickOrdersResponse } from "@/features/pathpick/features/order-history/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 패스픽 주문 목록 조회 훅 — 상단 탭 건수(statusCounts)도 같은 응답에서 함께 내려온다.
const useGetPathPickOrders = (params?: PathPickOrdersRequestParams) => {
  const { companyId } = useCompanyIdentity();

  const {
    data: pathPickOrderList,
    isPending,
    isPlaceholderData,
  } = useQuery({
    // companyId를 앞에 둬 prefix 무효화가 회사 단위로 걸리게 한다.
    queryKey: ["pathpick", "orders", companyId, params],
    // camel 변환을 queryFn에서 수행해 캐시 자체를 camel로 저장한다.
    queryFn: async () => {
      const data = await pathPickOrderHistoryQueryApi.getPathPickOrders(
        companyId as number,
        params
      );
      return toCamelKeyObject(data) as PathPickOrdersResponse;
    },
    enabled: Boolean(companyId),
    placeholderData: keepPreviousData,
  });

  return { pathPickOrderList, isPending, isPlaceholderData };
};

export default useGetPathPickOrders;
